import Vue from "vue";
import VueRouter from "vue-router";
// import store from "../store/index.js";
import mendian from "./children/mendian.js"; //工作台
import yiliaoxin from "./children/yiliaoxin.js"; //门店业务-医疗
import jiyangguanli from "./children/jiyangguanli.js";
import ximei from './children/ximei.js';
import yuyue from './children/yuyue.js';
import huiyuan from "./children/huiyuan.js";
import rechargeOrder from "./children/rechargeOrder.js";
import returnOrder from "./children/returnOrder.js";
import arrearsOrder from "./children/arrearsOrder.js";
import onlineOrder from "./children/onlineOrder.js";
import onlineReturn from "./children/onlineReturn.js";
import dingdan from "./children/dingdan.js";
import huotiMendian from "./children/huotiMendian.js";
import huotiCharge from "./children/huotiCharge.js";
import huotiHouse from './children/huotiHouse.js';
import huotiZongcang from "./children/huotiZongcang.js";
import huodong from "./children/huodong.js";
import goods from './children/goods.js';
import oa from './children/oa.js';
import ximeiyuyue from './children/ximeiyuyue.js';
import housePeizhi from "./children/housePeizhi.js";
import signature from "./children/signature.js";
import brand from "./children/brand.js";
import gongyingshang from "./children/gongyingshang.js";
import template from "./children/template.js";
import controlStaff from "./children/controlStaff.js";
import controlRole from "./children/controlRole.js";
import controlRight from "./children/controlRight.js";
import version from "./children/version.js";  //版本
import caigouMendian from "./children/caigouMendian.js";
import caigou from "./children/caigou.js";
import yujing from "./children/yujing.js";
import tiaoma from "./children/tiaoma.js";
import kucun from "./children/kucun.js";
import chuku from "./children/chuku.js";
import ruku from "./children/ruku.js";
import guoqi from "./children/guoqi.js";
// 新仓储管理  -------------
import caigouMendianNew from "./children/caigouMendianNew.js";
import caigouNew from "./children/caigouNew.js";
import yujingNew from "./children/yujingNew.js";
import kucunNew from "./children/kucunNew.js";
import chukuNew from "./children/chukuNew.js";
import rukuNew from "./children/rukuNew.js";
import pandian from "./children/pandian.js";
// ------------
import chanpin from "./children/chanpin.js";
import medical from "./children/medical.js"; //药品
import group from "./children/group.js";
import lifeservice from "./children/lifeservice.js";
import medicalservice from "./children/medicalservice.js";
import livingbody from "./children/livingbody.js";
import fictitious from "./children/fictitious.js"; //虚拟道具
import consumables from "./children/consumables.js";
import shuju from "./children/shuju.js";
import caiwu from "./children/caiwu.js";
import moneypk from "./children/moneypk.js";
import Newmoneypk from "./children/Newmoneypk.js";
import staffshuju from "./children/staffshuju.js";
import huotishuju from "./children/huotishuju.js";
import goodshuju from "./children/goodshuju.js";
import mall from './children/mall.js'
import file from "./children/file.js";
import dingding from "./children/dingding.js";
import fileStatistics from "./children/fileStatistics.js";
import jiaocheng from "./children/jiaocheng.js";

// ---------未知文件-------

import huotiStock from "./children/huotiStock.js";
import huifang from "./children/huifang.js";
import wuliao from "./children/wuliao.js";
import huoti from "./children/huoti.js";
import refund from "./children/refund.js";
import quanxian from "./children/quanxian.js";
import yingxiao from "./children/yingxiao.js";
import shezhi from "./children/shezhi.js";

import program from "./children/program.js";


Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("@/views/login.vue"),
    },
    {
      path: "/changePwd",
      component: () => import("@/views/frame/layout1440.vue"),
      children: [
        {
          path: "changePwd",
          component: () => import("@/views/changePwd.vue"),
        },
      ],
    },
  // 工作台
    {
      path: "/mendian",
      // redirect: "/mendian/shouyin",
      component: () => import("@/views/frame/layout1440.vue"),
      children: mendian,
    },
    //门店业务- 洗美管理
    {
      path: "/ximei",
      redirect: "/ximei/list",
      component: () => import("@/views/frame/layout1440.vue"),
      children: ximei,
    },
    //门店业务- 寄养管理
    {
      path: "/jiyang",
      redirect: "/jiyang/jiyangList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: jiyangguanli,
    },
    //门店业务- 医疗管理
    {
      path: "/yiliaoxin",
      // redirect: "/yiliaoxin/platform",
      component: () => import("@/views/frame/layout1440.vue"),
      children: yiliaoxin,
    },
    // 门店业务-预约管理
    {
      path: "/yuyue",
      // redirect: "/yuyue/yuyuePaiBan",
      component: () => import("@/views/frame/layout1440.vue"),
      children: yuyue,
    },
    // 会员管理
    {
      path: "/huiyuan",
      redirect: "/huiyuan/huiyuanList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huiyuan,
    },
    // 订单管理-消费订单
    {
      path: "/dingdan",
      redirect: "/dingdan/saleOrderList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: dingdan,
    },
    // 订单管理-充值订单
    {
      path: "/rechargeOrder",
      redirect: "/rechargeOrder/rechargeOrderList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: rechargeOrder,
    },
    // 订单管理-退换货订单
    {
      path: "/returnOrder",
      redirect: "/returnOrder/returnOrderList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: returnOrder,
    },
    // 订单管理-欠宠记录
    {
      path: "/arrearsOrder",
      redirect: "/arrearsOrder/arrearsOrderList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: arrearsOrder,
    },
    // 订单管理-线上订单订单
    {
      path: "/onlineOrder",
      redirect: "/onlineOrder/onlineOrderList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: onlineOrder,
    },
    // 线上退货订单
    {
      path: "/onlineReturn",
      redirect: "/onlineReturn/onlineReturnList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: onlineReturn,
    },

    // 活体管理-宠物房间
    {
      path: "/huotiHouse",
      // redirect: "/huotiHouse/pethouse",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huotiHouse,
      },
       // 活体管理-宠物列表
    {
      path: "/huotiZongcang",
      redirect: "/huotiZongcang/zongcang",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huotiZongcang,
    },
    // 活体管理-门店宠物
    {
      path: "/huotiMendian",
      redirect: "/huotiMendian/mendian",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huotiMendian,
    },
    // 活体管理-活体负责人
    {
      path: "/huotiCharge",
      redirect: "/huotiCharge/charger",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huotiCharge,
    },
    // 系统配置-活动配置
    {
      path: "/huodong",
      // redirect: "/huodong/huodongList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huodong,
    },
    // 系统配置-商品配置
    {
      path: "/goods",
      redirect: "/goods/goods",
      component: () => import("@/views/frame/layout1440.vue"),
      children: goods,
    },
    // 系统配置-消息配置
    {
      path: "/oa",
      // redirect: "/oa/messageList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: oa,
    },
    // 系统配置--洗美项目
    {
      path: "/ximeiyuyue",
      redirect: "/ximeiyuyue/yuyuePeiZhi",
      component: () => import("@/views/frame/layout1440.vue"),
      children: ximeiyuyue,
    },
    // 系统配置--宠物房
    {
      path: "/housePeizhi",
      redirect: "/housePeizhi/housePeizhi",
      component: () => import("@/views/frame/layout1440.vue"),
      children: housePeizhi,
    },
    // 系统配置--印章管理
     {
      path: "/signature",
      redirect: "/signature/signatureList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: signature,
    },
     // 系统配置--品牌管理
    {
      path: "/brand",
      redirect: "/brand/pinpaiList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: brand,
    },
     // 系统配置--供应商
    {
      path: "/gongyingshang",
      redirect: "/gongyingshang/gongyingshangList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: gongyingshang,
    },
     // 系统配置--合同模版
    {
      path: "/template",
      redirect: "/template/templateList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: template,
    },
     // 员工管理--版本编号
     {
      path: "/version",
      redirect: "/version/versionAdd",
      component: () => import("@/views/frame/layout1440.vue"),
      children: version,
    },
    // 员工管理--系统菜单
    {
      path: "/controlStaff",
      redirect: "/controlStaff/staff",
      component: () => import("@/views/frame/layout1440.vue"),
      children: controlStaff,
    },
    // // 员工管理--员工列表
    {
      path: "/controlRight",
      redirect: "/controlRight/right",
      component: () => import("@/views/frame/layout1440.vue"),
      children: controlRight,
    },
   
    // // 员工管理--角色管理
    {
      path: "/controlRole",
      redirect: "/controlRole/role",
      component: () => import("@/views/frame/layout1440.vue"),
      children: controlRole,
    },
   //仓储管理-门店采购
    {
      path: "/caigouMendian",
      redirect: "/caigouMendian/shopPurchase",
      component: () => import("@/views/frame/layout1440.vue"),
      children: caigouMendian,
    },
   //仓储管理-总仓采购
    {
      path: "/caigou",
      // redirect: "/caigou/shenpiList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: caigou,
    },
   //仓储管理-门店资产
    {
      path: "/wuliao",
      // redirect: "/wuliao/wuliaoList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: wuliao,
    },
     //仓储管理-库存预警
    {
      path: "/yujing",
      redirect: "/yujing/yujingList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: yujing,
    },
     //仓储管理-条码追踪
    {
      path: "/tiaoma",
      redirect: "/tiaoma/tiaoma",
      component: () => import("@/views/frame/layout1440.vue"),
      children: tiaoma,
    },
     //仓储管理-库存列表
    {
      path: "/kucun",
      redirect: "/kucun/kucunList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: kucun,
    },
    //仓储管理-出库记录
    {
      path: "/chuku",
      redirect: "/chuku/chukuList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: chuku,
    },
    //仓储管理-入库记录
    {
      path: "/ruku",
      redirect: "/ruku/rukuList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: ruku,
    },
    //仓储管理-过期预警
    {
      path: "/guoqi",
      redirect: "/guoqi/guoqiWarningList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: guoqi,
    },

    // 新的仓储管理--------------------------
     //仓储管理新-门店采购
     {
      path: "/caigouMendianNew",
      redirect: "/caigouMendianNew/shopPurchase",
      component: () => import("@/views/frame/layout1440.vue"),
      children: caigouMendianNew,
    },
   //仓储管理-总仓采购
    {
      path: "/caigouNew",
      // redirect: "/caigouNew/shenpiList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: caigouNew,
    },
   //仓储管理-门店资产 ---未改
    {
      path: "/pandian",
      redirect: "/pandian/pandianlist",
      component: () => import("@/views/frame/layout1440.vue"),
      children: pandian,
    },
     //仓储管理-库存预警
    {
      path: "/yujingNew",
      redirect: "/yujingNew/yujingList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: yujingNew,
    },
     //仓储管理-库存列表
    {
      path: "/kucunNew",
      redirect: "/kucunNew/kucunList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: kucunNew,
    },
    //仓储管理-出库记录
    {
      path: "/chukuNew",
      redirect: "/chukuNew/chukuList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: chukuNew,
    },
    //仓储管理-入库记录
    {
      path: "/rukuNew",
      redirect: "/rukuNew/rukuList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: rukuNew,
    },
    // -=--------------------------------------

  // 产品中心- 商品
    {
      path: "/chanpin",
      redirect: "/chanpin/goods",
      component: () => import("@/views/frame/layout1440.vue"),
      children: chanpin,
    },
    // 产品中心- 药品
    {
      path: "/medical",
      redirect: "/medical/medical",
      component: () => import("@/views/frame/layout1440.vue"),
      children: medical,
    },
    // // 产品中心- 套餐
    {
      path: "/group",
      redirect: "/group/group",
      component: () => import("@/views/frame/layout1440.vue"),
      children: group,
    },
    // 产品中心- 生活服务
    {
      path: "/lifeservice",
      redirect: "/lifeservice/lifeservice",
      component: () => import("@/views/frame/layout1440.vue"),
      children: lifeservice,
    },
    // 产品中心- 医疗服务
    {
      path: "/medicalservice",
      redirect: "/medicalservice/medicalservice",
      component: () => import("@/views/frame/layout1440.vue"),
      children: medicalservice,
    },
    // 产品中心- 活体
    {
      path: "/livingbody",
      redirect: "/livingbody/livingbody",
      component: () => import("@/views/frame/layout1440.vue"),
      children: livingbody,
    },
    // // 产品中心- 虚拟道具
    {
      path: "/fictitious",
      redirect: "/fictitious/fictitious",
      component: () => import("@/views/frame/layout1440.vue"),
      children: fictitious,
    },
    // 产品中心- 耗材
    {
      path: "/consumables",
      redirect: "/consumables/consumables",
      component: () => import("@/views/frame/layout1440.vue"),
      children: consumables,
    },
   // 数据中心-门店数据
    {
      path: "/shuju",
      redirect: "/shuju/mendianshuju",
      component: () => import("@/views/frame/layout1440.vue"),
      children: shuju,
    },
      // 数据中心-财务数据
    {
      path: "/caiwu",
      redirect: "/caiwu/export",
      component: () => import("@/views/frame/layout1440.vue"),
      children: caiwu,
    },
      // 数据中心-业绩pk
    {
      path: "/moneypk",
      redirect: "/moneypk/moneypk",
      component: () => import("@/views/frame/layout1440.vue"),
      children: moneypk,
    },
      // 数据中心-新业绩pk
      {
        path: "/Newmoneypk",
        // redirect: "/Newmoneypk/Newmoneypk",
        component: () => import("@/views/frame/layout1440.vue"),
        children: Newmoneypk,
      },
      // 数据中心-员工提成
    {
      path: "/staffshuju",
      redirect: "/staffshuju/staffshuju",
      component: () => import("@/views/frame/layout1440.vue"),
      children: staffshuju,
    },
      // 数据中心-活体统计
    {
      path: "/huotishuju",
      redirect: "/huotishuju/huoti",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huotishuju,
    },
       // 数据中心-商品统计
       {
        path: "/goodshuju",
        redirect: "/goodshuju/good",
        component: () => import("@/views/frame/layout1440.vue"),
        children: goodshuju,
      },
    // 商城管理
    {
      path: "/mall",
      redirect: "/mall/goodList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: mall,
    },
//  签章管理--全部合同
    {
      path: "/file",
      redirect: "/file/fileList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: file,
    },
    //  签章管理--合同统计
    // fileStatistics
    {
      path: "/fileStatistics",
      redirect: "/fileStatistics/fileStatistics",
      component: () => import("@/views/frame/layout1440.vue"),
      children: fileStatistics,
    },
    //  消息中心--钉钉配置
    {
      path: "/dingding",
      // redirect: "/dingding/edit",
      component: () => import("@/views/frame/layout1440.vue"),
      children: dingding,
    },
  //  教程
    {
      path: "/jiaocheng",
      redirect: "/jiaocheng/videoList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: jiaocheng,
    },









// ---------未知文件-------
    {
      path: "/huifang",
      redirect: "/huifang/huifangList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huifang,
    },
   
   {
      path: "/huotiStock",
      redirect: "/huotiStock/stock",
      component: () => import("@/views/frame/layout1440.vue"),
      children: huotiStock,
    },
   

   
    {
      path: "/huoti",
      redirect: "/huoti/huotiList",
      component: () => import("@/views/frame/layout.vue"),
      children: huoti,
    },
    {
      path: "/quanxian",
      redirect: "/quanxian/guahaoAdd",
      component: () => import("@/views/frame/layout.vue"),
      children: quanxian,
    },
    {
      path: "/yingxiao",
      redirect: "/yingxiao/guahaoAdd",
      component: () => import("@/views/frame/layout.vue"),
      children: yingxiao,
    },
 
  
    {
      path: "/refund",
      redirect: "/refund/approveList",
      component: () => import("@/views/frame/layout1440.vue"),
      children: refund,
    },
    {
      path: "/shezhi",
      redirect: "/shezhi/guahaoAdd",
      component: () => import("@/views/frame/layout.vue"),
      children: shezhi,
    },

    //小程序设置
    {
      path: "/program",
      redirect: "/program/advertising",
      component: () => import("@/views/frame/layout1440.vue"),
      children: program,
    },
    {
      path: "/petshop",
      redirect: "/petshop/petshop",
      component: () => import("@/views/frame/layout1440.vue"),
      children: [
        {
          path: "petshop",
          component: () => import("@/views/program/petshop/petshop.vue"),
          meta: { title: "宠物商城", keepAlive: true },
        },
        {
          path: "edit",
          component: () => import("@/views/program/petshop/editpetshop.vue"),
          meta: { title: "宠物商城设置" },
        },
      ],
    },
    {
      path: "/petlooking",
      redirect: "/petlooking/petlooking",
      component: () => import("@/views/frame/layout1440.vue"),
      children: [
        {
          path: "petlooking",
          component: () => import("@/views/program/petlooking.vue"),
          meta: { title: "宠物求购", keepAlive: true },
        },
      ],
    },
    {
      path: "/petgift",
      redirect: "/petgift/petgiftbag",
      component: () => import("@/views/frame/layout1440.vue"),
      children: [
        {
          path: "petgiftbag",
          component: () => import("@/views/program/petgiftbag/petgiftbag.vue"),
          meta: { title: "宠物礼包" },
        },
        {
          path: "edit",
          component: () =>
            import("@/views/program/petgiftbag/editpetgiftbag.vue"),
          meta: { title: "宠物礼包设置" },
        },
      ],
    },
    {
      path: "/breedplan",
      redirect: "/breedplan/breedplan",
      component: () => import("@/views/frame/layout1440.vue"),
      children: [
        {
          path: "breedplan",
          component: () => import("@/views/program/breedplan/breedplan.vue"),
          meta: { title: "饲养计划", keepAlive: true },
        },
        {
          path: "edit",
          component: () =>
            import("@/views/program/breedplan/editbreedplan.vue"),
          meta: { title: "饲养计划设置" },
        },
        {
          path: "detail",
          component: () => import("@/views/program/breedplan/breeddetail.vue"),
          meta: { title: "饲养计划详情" },
        },
      ],
    },
    {
      path: "/join",
      redirect: "/join/join",
      component: () => import("@/views/frame/layout1440.vue"),
      children: [
        {
          path: "join",
          component: () => import("@/views/program/join/join.vue"),
          meta: { title: "活动列表" },
        },
        {
          path: "list",
          component: () => import("@/views/program/join/list.vue"),
          meta: { title: "拼团列表" },
        },
        {
          path: "addJoin",
          component: () => import("@/views/program/join/addJoin.vue"),
          meta: { title: "新建活动" },
        },
        {
          path: "detail",
          component: () => import("@/views/program/join/detail.vue"),
          meta: { title: "拼团详情" },
        },
      ],
    },
    {
      path: "/special",
      redirect: "/special/special",
      component: () => import("@/views/frame/layout1440.vue"),
      children: [
        {
          path: "special",
          component: () => import("@/views/program/special/special.vue"),
          meta: { title: "限时特价" },
        },
        {
          path: "addSpecial",
          component: () => import("@/views/program/special/addSpecial.vue"),
          meta: { title: "新增特价" },
        },
      ],
    },
    {
      path: "/goodsShop",
      redirect: "/goodsShop/goodsShop",
      component: () => import("@/views/frame/layout1440.vue"),
      children: [
        {
          path: "goodsShop",
          component: () => import("@/views/program/goodsShop/goodsShop.vue"),
          meta: { title: "商品商城" },
        },
        {
          path: "upload",
          component: () => import("@/views/program/goodsShop/upload.vue"),
          meta: { title: "编辑" },
        },
      ],
    },
  
  ],
});
// router.beforeEach((to, from, next) => {
// 	console.log(to,from)
// 	next();
// })
// router.afterEach((to) => {
// 	let param = {title:to.meta.title,path:to.path}
// 	console.log(param,store)
// 	// if(to.path.split('/')[2]){
// 	// 	// if(to.path.split('/')[1]){

// 	// 	// }
// 	// 	store.commit("setCurNavIndex_"+to.path.split('/')[1],param)
// 	// }else{
// 	// 	router.push({path:store.state["curNavIndex_"+to.path.split('/')[1]].path})
// 	// }

// })
export default router;
